import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { DeviceStoreActions, DeviceStoreSelectors, DeviceStoreStates } from '@era/stores';
import { Device } from '@era/locations-sdk';
import { DeviceOsUpdateContinueComponent } from './device-os-update-continue.component';
import { DeviceOsUpdateResetComponent } from './device-os-update-reset.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-device-os-update-action-bar',
  templateUrl: './device-os-update-action-bar.container.html',
  styleUrls: ['./device-os-update-action-bar.container.scss'],
  imports: [DeviceOsUpdateContinueComponent, DeviceOsUpdateResetComponent, AsyncPipe],
})
export class DeviceOsUpdateActionBarContainerComponent {
  readonly device$: Observable<Device>;

  constructor(private readonly store: Store<DeviceStoreStates.DeviceState>) {
    this.device$ = this.store.select(DeviceStoreSelectors.selectDeviceByCurrentAppleDevice);
  }

  public reset(device: Device) {
    this.store.dispatch(DeviceStoreActions.DeviceSyncStatusViewActions.retryOsUpdate({ udid: device.deviceId }));
  }

  public continue(device: Device) {
    this.store.dispatch(DeviceStoreActions.DeviceSyncStatusViewActions.continueOsUpdate({ udid: device.deviceId }));
  }
}
